import React from 'react';
import PropTypes from 'prop-types';
import TimeAgo from 'react-timeago';

import { includes, truncate } from 'lodash-es';
import dayjs from 'util/date';
import striptags from 'striptags';

import LinkIf from 'components/Explorer/LinkIf';
import OutputsList from 'components/Explorer/OutputsList';
import QuotesIcon from 'icons/quotes-left.svg';

const VISIBLE_OUTPUTS_COUNT = 2;

class LatestMention extends React.Component {
  static propTypes = {
    post: PropTypes.object
  };

  state = {
    visible: false
  };

  render() {
    const { post } = this.props;
    const outputsCount = post.outputs.length;

    return (
      <div key={post.id} className="container">
        <div className="content">
          <div className={`marker ${post.postType}`}></div>
          <div className="title">
            <LinkIf condition={post.url && post.url.length > 0} url={post.url}>
              <span>
                {I18n.t('Explorer.Highlights.LatestMentions.mentioned')}{' '}
                <TimeAgo date={dayjs(post.postedAt).format('YYYY-MM-DD h:mm A UTC')} /> {this.sourceDescription}
              </span>
            </LinkIf>
          </div>
          {post.body && (
            <p className="quote">
              <QuotesIcon className="icon" />
              {truncate(striptags(post.body), {
                length: 250,
                separator: /\W/
              })}
            </p>
          )}
          <div className="outputs-container">
            <p className="outputs-title">
              {I18n.t('Explorer.Highlights.LatestMentions.cites', {
                count: outputsCount
              })}
              {outputsCount > VISIBLE_OUTPUTS_COUNT && (
                <button onClick={this.toggleOutputsVisibility} className="truncated-toggle">
                  {this.toggleOutputsVisibilityButtonText(outputsCount)}
                </button>
              )}
              :
            </p>
            <OutputsList
              post={post}
              outputs={post.outputs}
              visible={this.state.visible}
              visibleOutputsCount={VISIBLE_OUTPUTS_COUNT}
            />
          </div>
        </div>
      </div>
    );
  }

  toggleOutputsVisibility = () => {
    this.setState({ visible: !this.state.visible });
  };

  toggleOutputsVisibilityButtonText = (outputsCount) => {
    if (this.state.visible) {
      return I18n.t('Explorer.Highlights.LatestMentions.show_fewer');
    } else {
      return I18n.t('Explorer.Highlights.LatestMentions.cites_more', {
        count: Math.max(outputsCount - VISIBLE_OUTPUTS_COUNT, 0)
      });
    }
  };

  get sourceDescription() {
    const { post } = this.props;
    const sourcesWithName = ['tweet', 'msm', 'blog', 'policy', 'weibo', 'fbwall', 'gplus', 'rdt'];

    if ((!post.profile || !post.profile.name || !post.profile.name.length) && includes(sourcesWithName, post.postType))
      return;

    const options = {};
    if (post.profile && post.profile.name && post.profile.name.length) {
      options.name = post.profile.name;
    }

    return I18n.t(`Explorer.Highlights.LatestMentions.type_descriptions.${post.postType}`, options);
  }
}

export default LatestMention;
